import React from 'react';
import MultiSelect from '../../../../../components/inputs/MultiSelect';
import { usePlanoForm } from './Context';

const SelectClientPlanoForm = () => {
    const {clientId, setClientId, clients, loading} = usePlanoForm()

    return (
        <MultiSelect
            options={clients}
            loading={loading}
            value={clientId ? [clientId] : []}
            onChange={selected => setClientId(selected as string)}
            placeholder="Selecione o cliente"
            label="Cliente"
            name="cliente"
            multiple={false}
        />
    );
};

export default SelectClientPlanoForm;